import React, { useState, useEffect, useContext } from 'react';
import { Container, Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { CampaignType, CampaignStatus } from '../../../utils/enums'
import UsersAutoComplete from '../../Users/UsersAutoComplete';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthContext } from '../../../context/AuthContext';

const CreateForm = ({ onSubmit }) => {
    const { userId } = useContext(AuthContext);
    const [ownerId, setOwnerId] = useState(userId || '');
    const [campaignName, setCampaignName] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [expectedRevenue, setExpectedRevenue] = useState(0);
    const [actualCost, setActualCost] = useState(0);
    const [budgetedCost, setBudgetedCost] = useState(0);
    const [numbersSent, setNumbersSent] = useState(0);
    const [expectedResponse, setExpectedResponse] = useState(0);
    const [type, setType] = useState(0);
    const [status, setStatus] = useState(0);
    const [description, setDescription] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Collect all form data
        const formData = {
            ownerId,
            campaignName,
            startDate,
            endDate,
            expectedRevenue,
            actualCost,
            budgetedCost,
            numbersSent,
            expectedResponse,
            type,
            status,
            description
        };
        // Call onSubmit function passed as a prop
        onSubmit(formData);
    };

    useEffect(() => {
        if (userId) {
            setOwnerId(userId);
        }
    }, [userId]);

    return (
        <form id='create-form' onSubmit={handleSubmit}>
            <Container maxWidth="md" sx={{ marginTop: "10px" }}>
                <h4>Campaign Information</h4>
                <Grid container spacing={3}>
                    {/* Campaign Owner */}
                    <Grid item xs={12} sm={6}>
                        <UsersAutoComplete userId={userId} setUserId={setOwnerId} />
                    </Grid>

                    {/* Type ****** */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            options={CampaignType}
                            sx={{ width: "100%" }}
                            value={CampaignType.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setType(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Type" />}
                        />
                    </Grid>

                    {/* Campaign Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Campaign Name" required
                            onChange={(e) => setCampaignName(e.target.value)} />
                    </Grid>

                    {/* Status */}
                    <Grid item xs={12} sm={6}>
                    <Autocomplete
                            disablePortal
                            options={CampaignStatus}
                            sx={{ width: "100%" }}
                            value={CampaignStatus.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setStatus(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Status" />}
                        />
                    </Grid>

                    {/* Start Date */}
                    <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                fullWidth
                                onChange={(newDate) => setStartDate(newDate)}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        fullWidth: true
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* End Date */}
                    <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="End Date"
                                fullWidth
                                onChange={(newDate) => setEndDate(newDate)}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        fullWidth: true
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* Expected Revenue */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Expected Revenue"
                            onChange={(e) => setExpectedRevenue(e.target.value)} />
                    </Grid>

                    {/* Budgeted Cost */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Budgeted Cost"
                            onChange={(e) => setBudgetedCost(e.target.value)} />
                    </Grid>

                    {/* Actual Cost */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Actual Cost"
                            onChange={(e) => setActualCost(e.target.value)} />
                    </Grid>

                    {/* Expected Response */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Expected Response"
                            onChange={(e) => setExpectedResponse(e.target.value)} />
                    </Grid>

                    {/* Numbers sent */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Numbers sent"
                            onChange={(e) => setNumbersSent(e.target.value)} />
                    </Grid>
                </Grid >
                <br />
                <h4>Description Information</h4>
                <Grid container spacing={3}>
                    {/* Description */}
                    <Grid item xs={12} sm={12}>
                        <TextField multiline fullWidth label="Description"
                            onChange={(e) => setDescription(e.target.value)} />
                    </Grid>
                </Grid >
            </Container >
        </form>
    );
};

export default CreateForm;
